import { Link } from '@tanstack/react-router';
import { Play, ArrowRight, CheckCircle2 } from 'lucide-react';

import type { LearnResume } from './learnModel';

export function ContinueLearningCard({ batchId, resume }: { batchId: string; resume: LearnResume | null }) {
  if (!resume) {
    return (
      <div className="flex items-center gap-5 rounded-[24px] border border-[#efefef] bg-white p-[21px] shadow-[0px_2px_8px_rgba(0,0,0,0.04)]">
        <div className="flex size-[100px] shrink-0 items-center justify-center rounded-[20px]" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #c084fc 100%)' }}>
          <CheckCircle2 className="size-10 text-white" />
        </div>
        <div>
          <h2 className="pt-1 text-2xl font-bold leading-tight text-[#111827]">You&apos;re all caught up — every module complete.</h2>
          <p className="pt-1 text-sm text-[#6b7280]">Revisit any module below to review.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5 rounded-[24px] border border-[#efefef] bg-white p-[21px] shadow-[0px_2px_8px_rgba(0,0,0,0.04)] sm:flex-row sm:items-center">
      <div className="flex size-20 shrink-0 items-center justify-center rounded-[20px] sm:size-[100px]" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #c084fc 100%)' }}>
        <span className="flex size-10 items-center justify-center rounded-full bg-white/25">
          <Play className="size-[18px] translate-x-px fill-white text-white" />
        </span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-xs font-semibold uppercase leading-4 tracking-[0.3px] text-[#8b5cf6]">Continue Learning</p>
        <h2 className="pt-1 text-2xl font-bold leading-tight text-[#111827] sm:text-[28px] sm:leading-[35px]">{resume.topic.title}</h2>
        <div className="flex items-center gap-2 pt-2 text-sm text-[#6b7280]">
          <span>{resume.module.phase || 'Module'}</span>
          <span className="size-1 rounded-full bg-[#d1d5db]" />
          <span>Module {resume.module.sort_order}</span>
        </div>
        <div className="flex items-center gap-3 pt-3">
          <div className="h-2 flex-1 rounded-full bg-[#ede9fe]">
            <div className="h-2 rounded-full" style={{ width: `${resume.pct}%`, background: 'linear-gradient(to right, #8b5cf6, #c084fc)' }} />
          </div>
          <span className="text-sm font-semibold text-[#8b5cf6]">{resume.pct}%</span>
        </div>
      </div>

      <Link
        to="/courses/$batchId/topics/$topicId"
        params={{ batchId, topicId: resume.topic.id }}
        className="flex h-14 shrink-0 items-center justify-center gap-2 rounded-2xl px-6 text-[15px] font-semibold text-white shadow-[0px_4px_8px_rgba(139,92,246,0.35)] transition-opacity hover:opacity-90"
        style={{ background: 'linear-gradient(158.06deg, #8b5cf6 0%, #c084fc 100%)' }}
      >
        Continue
        <ArrowRight className="size-4" />
      </Link>
    </div>
  );
}
